import eventBus from '@/events/eventBus';

class ClientLogger {
    public log(message: string) {
        // tslint:disable-next-line:no-console
        console.log(message);
    }

    public debug(message: string) {
        eventBus.emit('debug-message', message);
    }
}

export default new ClientLogger();
